var TorsoView = require('backbone-torso/modules/View');
var appointmentConfigurationModel = require('./../../appointment-config/appointmentConfigurationModel');
var eregStaffPatientAppointmentSelectionLayoutTemplate = require('./eregStaffPatientAppointmentsLayoutTemplate.hbs');
var EregPatientAppointmentsListWidget = require('./../patient-appointments/EregPatientAppointmentsListWidget');
var PatientSummaryView = require('./../../patient-summary/PatientSummaryView');

/**
 * Perspective to display the E-reg staff-facing patient appointment selection page.
 *
 * @class EregStaffPatientAppointmentSelectionPerspective
 * @constructor
 * @param options {Object} options to configure this view.
 *   @param options.patientVecnaId {String} Vecna id of the patient that the appointment is for.
 */
module.exports = TorsoView.extend({
  className: 'page-content brec-main',
  attributes: {
    'data-test-ereg-staff-patient-appointment-selection': true
  },
  tagName: 'main',
  template: eregStaffPatientAppointmentSelectionLayoutTemplate,
  moduleNamespace: 'eregStaffPatientAppointmentSelection',

  /**
   * @method initialize
   * @param options {Object} options to configure this view.
   *   @param options.patientVecnaId {String} Vecna id of the patient that the appointment is for.
   * @override
   */
  initialize: function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentSelectionListView = new EregPatientAppointmentsListWidget({
      patientVecnaId : this._patientVecnaId,
      userIsStaff : true,
      appointmentTypes : EregPatientAppointmentsListWidget.prototype.REGULAR_ONLY
    });

    this._placeholderAppointmentSelectionListView = new EregPatientAppointmentsListWidget({
      patientVecnaId : this._patientVecnaId,
      userIsStaff : true,
      appointmentTypes : EregPatientAppointmentsListWidget.prototype.PLACEHOLDER_ONLY,
      hideIfEmpty : true
    });
    this._patientSummaryView = new PatientSummaryView({
      patientVecnaId: this._patientVecnaId,
      patientFacing: false
    });

    this.set({
      asideHeaderMessageKey: 'ereg.appointments.aside.header',
      asideContentMessageKey: 'ereg.staffPatientAppointment.aside'
    });

    this.set('navView', 'eregStaff');

    this.listenTo(appointmentConfigurationModel, 'load-complete', this.render);
    appointmentConfigurationModel.loadOnce();
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    return {
      showCreatePlaceholderButton: appointmentConfigurationModel.get('allowPlaceholderAppointments'),
      patientVecnaId: this._patientVecnaId
    };
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('patient-summary', this._patientSummaryView);
    this.attachView('appointment-list', this._appointmentSelectionListView);
    this.attachView('placeholder-appointment-list', this._placeholderAppointmentSelectionListView);
  }
});
